var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import style from './EnvironmentIndicator.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
import EnvUtil from '../utils/EnvUtil';
export default function EnvironmentIndicator() {
    var _a;
    var serviceType = useAperzaUserContext().serviceType;
    return (_jsx("span", __assign({ style: style, className: clsx(style.envBalloon, (_a = {}, _a[style["".concat(EnvUtil.getAppEnv())]] = EnvUtil.getAppEnv(), _a)) }, { children: "".concat(serviceType, "-").concat(EnvUtil.getAppEnv()) })));
}
